import { appSettings } from 'wanderu-config';
import { SnowplowService } from 'wanderu-service-analytics';

const gtagEvent = ({
    event, origin, destination, startDate, endDate, value,
}) => {
    if (typeof window?.gtag !== 'function') {
        return;
    }

    window.gtag('event', event, {
        items: [{
            destination,
            end_date: endDate,
            google_business_vertical: 'travel',
            origin,
            start_date: startDate,
        }],
        send_to: appSettings?.config?.google?.gtag,
        user_id: SnowplowService.getNetworkUserId(),
        value,
    });
};

const gtagSet = (key, value) => {
    if (typeof window?.gtag !== 'function') {
        return;
    }

    window.gtag('set', key, value);
};

export {
    gtagEvent,
    gtagSet,
};
